import { Component, OnInit } from '@angular/core';
import { Centro } from './centro';
import { CentroService } from './centro.service';
import { UnidadeService } from './../unidades/unidade.service';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-centros',
  templateUrl: './centros.component.html',
  styleUrls: ['./centros.component.css'],
  providers: [UnidadeService, CentroService]
})
export class CentrosComponent implements OnInit {
  public busy: Promise<any>;
  public centros: Centro[];
  titulo: string = "Centros";
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;

  constructor(
    private unidadeService: UnidadeService,
    private centroService: CentroService
  ) { }

  getCentros(): void {

   this.busy = this.centroService.getCentros()
      .then((centros) => this.centros = centros);
  }

  apagar(centro: Centro): void {
  // this.toastyService.default('Hi there');

    if(confirm("Deseja realmente excluir essa unidade? Essa operação não pode ser revertida após a confirmação.")){
      this.busy = this.centroService.deleteCentro(centro)
            .then(() => this.getCentros());
    }
  }

  ngOnInit() {
    this.getCentros();
  }

}



// WEBPACK FOOTER //
// ./src/app/centros/centros.component.ts